import React from "react";
import HeroV2 from "@/components/Common/HeroV2";
import { createClient } from "../../prismicio";
import Layout from "@/components/Layout";
import Metadata from "@/components/Metadata";
import SchemaScript from "@/components/SchemaScript";
import Breadcrumbs from "@/components/Common/Breadcrumbs";
import BridgeLoansForm from "@/components/Common/BridgeLoansForm";
import FeaturesAndBenefits from "@/components/FeaturesAndBenefits/FeaturesAndBenefits";
import TypicalLoanTerms from "@/components/Common/TypicalLoanTerms";

const BridgeLoans = ({ page, globals }) => {
  const pageData = page?.data;
  const commonComponents = globals?.data;

  return (
    <Layout data={commonComponents}>
      <SchemaScript data={pageData?.schema_json} />
      <Metadata
        title={pageData?.metadata_title || ""}
        description={pageData?.metadata_desc || ""}
        image={pageData?.metadata_image?.url}
        path="/bridge-loans"
      />
      <HeroV2
        caption={pageData?.hero_caption}
        title={pageData?.hero_title}
        description={pageData?.hero_description}
        viewMore={true}
        backgroundImage={pageData?.hero_background_image}
        backgroundImageAlt={pageData?.hero_background_image.alt}
        page={"Bridge Loans"}
      />
      <Breadcrumbs />
      <FeaturesAndBenefits data={pageData} />
      <TypicalLoanTerms data={pageData} />
      <BridgeLoansForm whiteBg />
    </Layout>
  );
};

export default BridgeLoans;

export async function getStaticProps({ previewData }) {
  const client = createClient({ previewData });

  const page = await client.getSingle("bridge_loans_page");
  const globals = await client.getSingle("globals");

  return {
    props: {
      page,
      globals,
    },
  };
}
